type Props = {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
};

/** 先頭・末尾・現在ページ±1 のみを残し、飛んだ箇所を 'ellipsis' で表すページ番号一覧を作る。 */
function getPageNumbers(currentPage: number, totalPages: number): (number | 'ellipsis')[] {
  const pages = new Set<number>();
  pages.add(1);
  pages.add(totalPages);
  for (let p = currentPage - 1; p <= currentPage + 1; p += 1) {
    if (p >= 1 && p <= totalPages) pages.add(p);
  }
  const sorted = Array.from(pages).sort((a, b) => a - b);

  const result: (number | 'ellipsis')[] = [];
  let prev = 0;
  for (const p of sorted) {
    if (prev !== 0 && p - prev > 1) {
      result.push('ellipsis');
    }
    result.push(p);
    prev = p;
  }
  return result;
}

export default function Pagination({ currentPage, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;

  const pages = getPageNumbers(currentPage, totalPages);

  return (
    <nav className="pagination" aria-label="ページ送り">
      <button
        type="button"
        className="btn pagination__nav"
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage <= 1}
        aria-label="前のページへ"
      >
        前へ
      </button>
      <ul className="pagination__list">
        {pages.map((p, i) =>
          p === 'ellipsis' ? (
            <li key={`ellipsis-${i}`}>
              <span className="pagination__ellipsis">…</span>
            </li>
          ) : (
            <li key={p}>
              <button
                type="button"
                className={`pagination__num${p === currentPage ? ' on' : ''}`}
                onClick={() => onChange(p)}
                aria-current={p === currentPage ? 'page' : undefined}
              >
                {p}
              </button>
            </li>
          ),
        )}
      </ul>
      <button
        type="button"
        className="btn pagination__nav"
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage >= totalPages}
        aria-label="次のページへ"
      >
        次へ
      </button>
    </nav>
  );
}
